import React, { useEffect, useRef, useState } from 'react'
import { Dropdown, Icon, Menu, Modal, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { TimesheetProjectMode, TimesheetsStore } from '../stores/timesheets-store'
import EditableTooltip from 'src/components/editable-tooltip/tooltip'

interface TimeSheetButtonProps {
  onLoad: (loading: boolean) => void,
  companyId: string,
  employeeId: string,
  isSameWeekAsFirstMonday: boolean,
  showBtnClone: boolean,
  timesheetId: string
}

const timesheetsStore = new TimesheetsStore()

const TimeSheetButton: React.FC<TimeSheetButtonProps> = ({ onLoad, companyId, employeeId, isSameWeekAsFirstMonday, showBtnClone, timesheetId }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedProjects, setSelectedProjects] = useState<string[]>([])
  const [projectData, setProjectData] = useState<any[]>([])
  const [selectmenu, setSelectmenu] = useState('')
  const { t } = useTranslation()
  const [currentCompany, setCurrentCompany] = useState(companyId)
  const [companyValue, setCompanyValue] = useState<boolean>(false)

  const inputRef = useRef()

  useEffect(
    () => {
      fetchData()
    }, [inputRef]
  )

  useEffect(() => {
    if (companyId && companyId != currentCompany) {
      fetchData()
      setCurrentCompany(companyId)
    }
  }, [companyId])

  const fetchData = async () => {
    try {
      timesheetsStore.setBaseUrl(companyId)
      const companyData = await timesheetsStore.getCompanyTimesheetManual()
      if (typeof companyData === 'boolean') {
        setCompanyValue(companyData)
      }
    } catch (error) {
      console.error("Error al obtener los datos de la compañía:", error)
    }
  }

  const handleOptionSelect = async (key: any) => {
    onLoad(true);
    setSelectmenu(key)
    timesheetsStore.setBaseUrl(companyId)

    if (key == 'createSpecificTimeSheet') {
      handleModalOpen()
    }
    else if (key == 'cloneWeek') {
      await timesheetsStore.generateTimesheetsWeek(employeeId, key, [], timesheetId)
      onLoad(false)
    }
    else {
      await timesheetsStore.generateTimesheetsWeek(employeeId, key, [])
      onLoad(false)
    }
  }

  const handleModalOpen = async () => {
    try {
      setModalVisible(true)
      const data = await timesheetsStore.getProjectEmployeeAsync(employeeId)
      setProjectData(data)
    } catch (error) {
      console.error("Error al obtener los proyectos:", error)
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    setSelectedProjects([])
  }

  const handleProjectSelect = (selectedOption: any) => {
    setSelectedProjects(selectedOption)
  }

  const handleGenerateTimeSheet = async () => {
    const selectedProjectObjects: TimesheetProjectMode[] = selectedProjects.map(jsonString => JSON.parse(jsonString))
    setModalVisible(false)
    setSelectedProjects([])

    await timesheetsStore.generateTimesheetsWeek(employeeId, selectmenu, selectedProjectObjects)
    onLoad(false)
  }

  const generateTimeSheetOptions = (
    <Menu>
      <Menu.Item key={'cloneWeek'} onClick={() => handleOptionSelect('cloneWeek')}>
        {t('Clone the previous week')}
      </Menu.Item>
      <Menu.Item key={'cloneWithoutEmptyLines'} onClick={() => handleOptionSelect('cloneWithoutEmptyLines')}>
        {t('Clone the previous week without empty lines')}
      </Menu.Item>
      <Menu.Item key={'createSpecificTimeSheet'} onClick={() => handleOptionSelect('createSpecificTimeSheet')}>
        {t('Create a specific time sheet')}
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      {(!isSameWeekAsFirstMonday && companyValue && showBtnClone) && (
        <>
          <EditableTooltip name='timesheet-Button' noIcon>
            <Dropdown.Button overlay={generateTimeSheetOptions}>
              {t('Generate Time Sheet')}  <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} />
            </Dropdown.Button>
          </EditableTooltip>
          <Modal
            title={t('Select Projects')}
            visible={modalVisible}
            onCancel={handleModalClose}
            onOk={handleGenerateTimeSheet}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              onChange={handleProjectSelect}
              placeholder={t('Select a project')}
            >
              {projectData.map(pro => (
                <Select.Option
                  key={pro.projectId}
                  value={JSON.stringify(pro)}
                  style={{ maxWidth: 450, wordWrap: 'break-word', whiteSpace: 'normal' }}>
                  {pro.projectTitle}
                </Select.Option>
              ))}
            </Select>
          </Modal>
        </>
      )}
    </>
  )
}

export default TimeSheetButton
